import { render, staticRenderFns } from "./searchItem.vue?vue&type=template&id=63fc46c7&scoped=true&"
import script from "./searchItem.vue?vue&type=script&lang=js&"
export * from "./searchItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fc46c7",
  null
  
)

export default component.exports